import axiosInstance from '@/core/api'
import type { paths } from '@/schema'

type GetShopPurchasesQuery =
	paths['/api/admin/shop/purchases']['get']['parameters']['query']
type GetShopPurchasesResponse =
	paths['/api/admin/shop/purchases']['get']['responses']['200']['content']['application/json']
type ProcessPurchaseBody =
	paths['/api/admin/shop/purchases/{id}/process']['patch']['requestBody']['content']['application/json']
type ProcessPurchaseResponse =
	paths['/api/admin/shop/purchases/{id}/process']['patch']['responses']['200']['content']['application/json']
type GetPurchaseByIdResponse =
	paths['/api/admin/shop/purchases/{id}']['get']['responses']['200']['content']['application/json']

export class ShopPurchasesService {
	static async getShopPurchases(
		query?: GetShopPurchasesQuery,
	): Promise<GetShopPurchasesResponse> {
		const { data } = await axiosInstance.get<GetShopPurchasesResponse>(
			'/admin/shop/purchases',
			{
				params: query,
			},
		)
		return data
	}

	static async getPurchaseById(id: string): Promise<GetPurchaseByIdResponse> {
		const { data } = await axiosInstance.get<GetPurchaseByIdResponse>(
			`/admin/shop/purchases/${id}`,
		)
		return data
	}

	static async processPurchase(
		id: string,
		body: ProcessPurchaseBody,
	): Promise<ProcessPurchaseResponse> {
		const { data } = await axiosInstance.patch<ProcessPurchaseResponse>(
			`/admin/shop/purchases/${id}/process`,
			body,
		)
		return data
	}
}
